import React from 'react'
import PostListItem from './PostListItem'
import EmptyState from '@components/shared/Empty'

import styles from '@components/blog/styles/PostList.module.css'

function PostList (props) {
    const { loading, data } = props
    const noResults = !loading && data?.length === 0

    return noResults
        ? <EmptyState />
        : (
            <div className={styles.list}>
                {
                    data.map(post => <PostListItem
                        key={post.slug}
                        post={post}
                    />)
                }
            </div>
        )
}

export default PostList